import { Next } from '@securitize/ui-components';

export const GET_LIQUIDITY_PROVIDERS_NEXT = new Next('/liquidity-providers', 'GET_LIQUIDITY_PROVIDERS_NEXT');
